import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-023102e2")

_pushScopeId("data-v-023102e2")
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "authorization authorization--login" }
const _hoisted_6 = { class: "authorization__form authorization__form--shadow" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "__title" }, "Reset your password", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "input-wrp" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "reset-message" }, " Enter your user account's verified email address and we will send you a password reset link. ", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "reset-message" }, " Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder. ", -1)
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" page ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_alert = _resolveComponent("a-alert")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              (!_ctx.send)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createVNode("input", {
                        class: "textfield textfield--grey",
                        type: "text",
                        placeholder: "Email",
                        inputmode: "email",
                        "x-inputmode": "email",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.email = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.email]
                      ])
                    ]),
                    _createVNode("button", {
                      class: "custom-btn custom-btn--medium custom-btn--style-1 wide",
                      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.register(...args))),
                      disabled: _ctx.buttonDisable
                    }, _toDisplayString(_ctx.buttonText), 9, ["disabled"]),
                    (_ctx.error)
                      ? (_openBlock(), _createBlock(_component_a_alert, {
                          key: 0,
                          message: "Check your email address",
                          type: "error",
                          showIcon: "",
                          class: "mt-15"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.send)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true),
              _createVNode("p", _hoisted_13, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _hoisted_15
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})